import { RestService, Rest } from '@abp/ng.core';
import type { PagedAndSortedResultRequestDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ActivitySyncDto, MachineSyncDto, ProgrammingSyncDto, ShiftSyncDto, SynchronizationOutputDto, TeamSyncDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class SynchronizationsService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getActivities = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<ActivitySyncDto>>({
      method: 'GET',
      url: '/synchronization/activities',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getMachines = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<MachineSyncDto>>({
      method: 'GET',
      url: '/synchronization/machines',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getProgrammings = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<ProgrammingSyncDto>>({
      method: 'GET',
      url: '/synchronization/programmings',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getShifts = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<ShiftSyncDto>>({
      method: 'GET',
      url: '/synchronization/shifts',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getTeams = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationOutputDto<TeamSyncDto>>({
      method: 'GET',
      url: '/synchronization/teams',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
}